import db from '@/utils/indexed-db';
import { useEffect, useState } from 'react';

export const useRecentStylepacks = () => {
  const [recentIds, setRecentIds] = useState<string[] | null>(null);

  useEffect(() => {
    db.get<string[]>('recent', 'stylepacks')
      .then((recent) => {
        if (recent?.data) {
          setRecentIds(recent.data);
        }
      })
      .catch(console.error);
  }, []);

  return recentIds;
};
